import { Injectable } from '@angular/core';
import { reportDownloadResponse } from '@interface/reportDownload';
import { get } from '../../interceptors/fetch-client';

@Injectable({
  providedIn: 'root',
})
export class ReportDownloadService {
  constructor() {}

  public async reportDownload(url: string): Promise<reportDownloadResponse> {
    try {
      const response = await get<reportDownloadResponse>(url, {}, true);
      if (response.ok && response.parsedBody) {
        return response.parsedBody;
      } else {
        // Return a failure response if the server response is not OK
        return { reportDownloadOutput: [] };
      }
    } catch {
      return { reportDownloadOutput: [] };
    }
  }
}
